// extracted by mini-css-extract-plugin
module.exports = {"root":"_81e578","numbersColumn":"_96b9f2","ratingValue":"_662338","linearProgressBarsContainer":"_f268b2","linearProgressContainer":"_1cde3a","numberOfSpecificReviews":"_3be4b4"};